import { useCallback, useEffect, useRef, useState } from "react";
import { useApi } from "../../lib/api";

export function useSpaceState(spaceId) {
  const api = useApi();
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);
  const [messages, setMessages] = useState([]);
  const last = useRef("");

  const poll = useCallback(async () => {
    try {
      const { data } = await api.get(`/spaces/${spaceId}/state`, { params: { since: last.current } });
      setError(null);
      setState(data);
      if (data.messages.length) {
        last.current = data.messages[data.messages.length - 1].created_at;
        setMessages((m) => [...m, ...data.messages.filter((x) => !m.some((y) => y.id === x.id))].slice(-200));
      }
    } catch (e) {
      setError({ status: e.response?.status, detail: e.response?.data?.detail });
    }
  }, [api, spaceId]);

  useEffect(() => {
    last.current = "";
    setMessages([]);
    poll();
    const t = setInterval(poll, 2500);
    return () => {
      clearInterval(t);
      api.post(`/spaces/${spaceId}/leave`).catch(() => {});
    };
  }, [poll, api, spaceId]);

  return { state, error, messages, setMessages, refresh: poll };
}
